import { motion } from "framer-motion";

// One look for every journey's tag: a deep ink pill with warm off-white text (well above 4.5:1 on any projection).
export const CTA_CLASS =
  "cta-glow whitespace-nowrap rounded-full border border-[#E9C987]/60 bg-[#22152F]/[0.88] px-8 py-2.5 font-display text-xl text-[#FFF4DC] shadow-[0_12px_30px_-10px_rgba(20,10,35,0.7)] backdrop-blur-md transition-[background-color,transform] duration-300 [text-shadow:none] hover:bg-[#22152F] active:scale-[0.97] select-none [-webkit-tap-highlight-color:transparent] [touch-action:manipulation]";

// Bottom-centre, above the safe area and clear of the heart, captions and corner controls; the same on every screen.
export function JourneyCTA({ show = true, children, testid = "journey-cta" }) {
  return (
    <motion.div
      data-testid={testid}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: show ? 1 : 0, y: show ? 0 : 10 }}
      transition={{ duration: 0.8 }}
      style={{ x: "-50%", pointerEvents: show ? "auto" : "none" }}
      className="journey-cta fixed left-1/2 z-[85] flex w-max max-w-[92vw] flex-col items-center gap-2.5 sm:flex-row"
    >
      {children}
    </motion.div>
  );
}
